export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section
      className="relative bg-[#0A1A36] text-white overflow-hidden"
      data-testid="page-hero"
    >
      <div className="absolute inset-0 ag-grid-lines opacity-40" />
      <div className="absolute -top-12 -right-12 h-64 w-64 border border-[#D4AF37]/30 rotate-12" />
      <div className="absolute -bottom-16 -left-16 h-72 w-72 border border-[#D4AF37]/20" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-12 bg-[#D4AF37]" />
          <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#D4AF37]">
            {eyebrow}
          </span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black leading-[0.95] tracking-tighter max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-lg text-white/80 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
